import { render, staticRenderFns } from "./MembershipTagsForm.vue?vue&type=template&id=042b68d3&scoped=true&"
import script from "./MembershipTagsForm.vue?vue&type=script&lang=js&"
export * from "./MembershipTagsForm.vue?vue&type=script&lang=js&"
import style0 from "./MembershipTagsForm.vue?vue&type=style&index=0&id=042b68d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042b68d3",
  null
  
)

export default component.exports